import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import i18next from 'i18next';

import { TextInput } from '../TextInput';
import { SelectInput } from '../SelectInput';
import { PageLevelAccess } from '../PageLevelAccess';
import { TagsService } from '../../services';

import config from "config";

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-tag-name');
  }

  if (!values.tagType) {
    errors.tagType = i18next.t('messages.please-select-tag-type');
  }

  return errors;
};

@connect(state => {
  return {
    form: state.form
  }
})
class TagForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      availableTagTypes: [],
      showDeleteModal: false
    }

    let initData = {
      name: props.tag.name,
      tagType: null
    }

    if (props.tag.tagType) {
      initData.tagType = { value: props.tag.tagType.id, label: i18next.t(`tag-types.${props.tag.tagType.token}`) }
    };

    this.props.initialize(initData);
  }

  componentDidMount() {
    TagsService.getAllTypes().then((response) => {
      this.setState({ availableTagTypes: response.types.map(type => ({ value: type.id, label: i18next.t(`tag-types.${type.token}`) })) });
    }).catch((error) => {
      console.log(error);
    })
  }

  toggleDeleteModal() {
    this.setState({showDeleteModal: !this.state.showDeleteModal});
  }

  render() {
    const { handleSubmit } = this.props;
    const tagName = this.props.form.TagForm.values && this.props.form.TagForm.values.name ? this.props.form.TagForm.values.name : this.props.tag.name;
    return (
      <div className="login-form tag-form">
        <form onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} sm={4}>
              <div className="form-tag">
                <Field
                  name="name"
                  type="text"
                  component={TextInput}
                  label={i18next.t('form-labels.name')}
                />
              </div>
            </Col>
            <Col xs={12} sm={4}>
              <div className="form-tag">
                  <label>{i18next.t('pages.tags.tag-type')}</label>
                  <Field
                  name="tagType"
                  options={this.state.availableTagTypes}
                  component={SelectInput}
                  />
              </div>
            </Col>

            <PageLevelAccess to='/admin/tags/edit/:tagId#delete'>
            {this.props.onDelete ?  <div className="pull-right tooltip">
                <img style={{paddingRight: 15}} className="tag-form-delete-button" src={`${config.WEB_BASE_URL}/images/icon/delete-trash-can.svg`} onClick={this.toggleDeleteModal.bind(this)}/>
                <span className="tooltiptext">{i18next.t('delete')}</span>
                </div> : null}              
            </PageLevelAccess>
          </Row>
          <ul style = {{paddingTop: 20}} className="list-inline clearfix">
            <li><button type="submit" className="btn btn-primary">{i18next.t('form-labels.save')}</button></li>
            <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/admin/tags`}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link></li>
          </ul>

          <Modal show={this.state.showDeleteModal} onHide={this.toggleDeleteModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>{i18next.t('pages.tags.delete-tag', {tag: tagName})}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {i18next.t('messages.are-you-sure-delete')}
              </Modal.Body>
              <Modal.Footer>
                <a className="btn btn-danger" onClick={()=>this.props.onDelete()}>{i18next.t('delete')}</a>
                <Button onClick={this.toggleDeleteModal.bind(this)}>{i18next.t('form-labels.cancel')}</Button>
              </Modal.Footer>
            </Modal>
        </form>
      </div>
    );
  }
}

export default reduxForm({ form: 'TagForm', validate })(TagForm);
